var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopNavGoBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1 4.1A13.908 13.908 0 0114 0a13.91 13.91 0 019.9 4.1A13.908 13.908 0 0128 14a13.91 13.91 0 01-4.1 9.9A13.908 13.908 0 0114 28a13.91 13.91 0 01-9.9-4.1A13.908 13.908 0 010 14a13.91 13.91 0 014.1-9.9zM14 26.527c6.907 0 12.526-5.619 12.526-12.526S20.907 1.474 14 1.474 1.474 7.093 1.474 14 7.093 26.526 14 26.526z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.374 13.48l5.895-5.896a.737.737 0 111.042 1.042l-4.637 4.637h15.168a.737.737 0 010 1.474H7.674l4.636 4.637a.737.737 0 11-1.041 1.042L5.374 14.52a.737.737 0 010-1.042z"
  }))));
}

export default SvgTopNavGoBack;